const getPrices = (orderLineItem)=>{
    var ref, ref1;
    var ref2;
    const lineItemOriginalPrice = (ref2 = (ref = orderLineItem.price) === null || ref === void 0 ? void 0 : ref.productPrice) !== null && ref2 !== void 0 ? ref2 : 0;
    var ref3;
    const totalPaid = (ref3 = (ref1 = orderLineItem.price) === null || ref1 === void 0 ? void 0 : ref1.totalPaid) !== null && ref3 !== void 0 ? ref3 : 0;
    const lineItemDiscountedPrice = totalPaid === lineItemOriginalPrice ? 0 : totalPaid;
    return {
        originalPrice: lineItemOriginalPrice,
        discountPrice: lineItemDiscountedPrice,
        price: lineItemDiscountedPrice ? lineItemOriginalPrice : totalPaid
    };
};

export { getPrices };
//# sourceMappingURL=get-prices.js.map
